import React from 'react';
import ContentLoader from 'react-content-loader';

import Theme from 'styles/theme';

const WIDTH = 375;
const HEIGHT = 150;
const IMAGE_SIZE = 100;
const SPACING = 24;
const TEXT_WIDTH = 140;
const TEXT_HEIGHT = 15;
const SIZE_WIDTH = 50;

const Image = () => <rect x={SPACING} y={SPACING} width={IMAGE_SIZE} height={IMAGE_SIZE} />;
const Title = () => (
  <rect x={IMAGE_SIZE + SPACING * 2} y={SPACING} width={TEXT_WIDTH} height={TEXT_HEIGHT} />
);
const Subheading = () => (
  <rect x={IMAGE_SIZE + SPACING * 2} y={SPACING * 2} width={TEXT_WIDTH} height={TEXT_HEIGHT} />
);
const Size = () => (
  <rect x={IMAGE_SIZE + SPACING * 2} y={SPACING * 3} width={SIZE_WIDTH} height={TEXT_HEIGHT} />
);

const Placeholder = props => (
  <ContentLoader
    height={HEIGHT}
    width={WIDTH}
    speed={1}
    primaryColor={Theme.get('colors-grey')}
    secondaryColor={Theme.get('colors-grey')}
    style={{ maxWidth: `${WIDTH}px` }}
    {...props}
  >
    <Image />
    <Title />
    <Size />
    <Subheading />
  </ContentLoader>
);

export default Placeholder;
